import Mutations from '../../odata/mutations';

export default {
  ...new Mutations('quoteAttachment'),
  ...new Mutations('quoteAttachments'),
  ADD_attachments: (state, payload) => {
    state.attachments.push(payload);
  },
};
